const routes = [
    {
        path: "/",
        name: "首页",
        redirect: "/index"
    },
    {
        path: "/login",
        name: "login",
        meta: {
            title: "登录"
        },
        component: () => import("@/views/login.vue")
    },
    {
        path: "/index",
        name: "index",
        meta: {
            title: "首页"
        },
        component: () => import("@/views/index.vue")
    },
    {
        path: "/industryIndex",
        name: "industryIndex",
        meta: {
            title: "乐田工业",
            permissionRely: "/index" // 权限依赖，当前值在权限列表中时，当前菜单也有访问权限，值为依赖菜单的path
        },
        component: () => import("@/views/industryIndex.vue")
    },
    {
        path: "/videoScreen",
        name: "videoScreen",
        meta: {
            title: "视频页",
            permissionRely: "/index" // 权限依赖，当前值在权限列表中时，当前菜单也有访问权限，值为依赖菜单的path
        },
        component: () => import("@/views/videoScreen.vue")
    },
    {
        path: "/industryVideoScreen",
        name: "industryVideoScreen",
        meta: {
            title: "视频页",
            permissionRely: "/index" // 权限依赖，当前值在权限列表中时，当前菜单也有访问权限，值为依赖菜单的path
        },
        component: () => import("@/views/industryVideoScreen.vue")
    },

    // 溯源码
    {
        path: "/productInfo",
        name: "productInfo",
        meta: {
            title: "产品详情",
            nopermission: true, // 不用设置权限即可访问
            nologin: true // 不用登录即可访问
        },
        component: () => import("@/views/source/productInfo.vue")
    },
    {
        path: "/companyInfo",
        name: "companyInfo",
        meta: {
            title: "企业介绍",
            nopermission: true, // 不用设置权限即可访问
            nologin: true // 不用登录即可访问
        },
        component: () => import("@/views/source/companyInfo.vue")
    },
    {
        path: "/sourceInfo",
        name: "sourceInfo",
        meta: {
            title: "溯源信息",
            nopermission: true, // 不用设置权限即可访问
            nologin: true // 不用登录即可访问
        },
        component: () => import("@/views/source/sourceInfo.vue")
    },
    {
        path: "/monitorInfo",
        name: "monitorInfo",
        meta: {
            title: "实时监控",
            nopermission: true, // 不用设置权限即可访问
            nologin: true // 不用登录即可访问
        },
        component: () => import("@/views/source/monitorInfo.vue")
    },
    {
        path: "/reportInfo",
        name: "reportInfo",
        meta: {
            title: "检测报告",
            nopermission: true, // 不用设置权限即可访问
            nologin: true // 不用登录即可访问
        },
        component: () => import("@/views/source/reportInfo.vue")
    },
    {
        path: "/cooperationInfo",
        name: "cooperationInfo",
        meta: {
            title: "客户信息",
            nopermission: true, // 不用设置权限即可访问
            nologin: true // 不用登录即可访问
        },
        component: () => import("@/views/source/cooperationInfo.vue")
    },

    // 管理端
    {
        path: "/admin",
        name: "layoutMain",
        props: true,
        component: () => import("@/components/layout/layoutMain.vue"),
        redirect: "/admin/index",
        children: [
            {
                path: "index",
                name: "adminIndex",
                props: true,
                meta: {
                    title: "管理端首页"
                },
                component: () => import("@/views/admin/index.vue")
            },
            {
                path: "menuManage",
                name: "menuManage",
                props: true,
                meta: {
                    title: "菜单管理"
                },
                component: () => import("@/views/admin/manage/menuManage.vue")
            },
            {
                path: "userManage",
                name: "userManage",
                props: true,
                meta: {
                    title: "用户管理"
                },
                component: () => import("@/views/admin/manage/userManage.vue")
            },
            {
                path: "roleManage",
                name: "roleManage",
                props: true,
                meta: {
                    title: "角色管理"
                },
                component: () => import("@/views/admin/manage/roleManage.vue")
            },
            {
                path: "companyManage",
                name: "companyManage",
                props: true,
                meta: {
                    title: "公司信息管理"
                },
                component: () => import("@/views/admin/manage/companyManage.vue")
            },
            {
                path: "departmentManage",
                name: "departmentManage",
                props: true,
                meta: {
                    title: "部门管理"
                },
                component: () => import("@/views/admin/manage/departmentManage.vue")
            },
            {
                path: "templateManage",
                name: "templateManage",
                props: true,
                meta: {
                    title: "模板管理"
                },
                component: () => import("@/views/admin/manage/templateManage.vue")
            },

            // 土壤墒情
            {
                path: "dataMonitoring",
                name: "dataMonitoring",
                props: true,
                meta: {
                    title: "温湿度氮磷钾"
                },
                component: () => import("@/views/admin/soil/dataMonitoring.vue")
            },
            {
                path: "phConductivity",
                name: "phConductivity",
                props: true,
                meta: {
                    title: "ph"
                },
                component: () => import("@/views/admin/soil/phConductivity.vue")
            },
            // 地块管理
            {
                path: "areaManage",
                name: "areaManage",
                props: true,
                meta: {
                    title: "区域管理"
                },
                component: () => import("@/views/admin/plot/areaManage.vue")
            },
            {
                path: "plotManage",
                name: "plotManage",
                props: true,
                meta: {
                    title: "地块管理"
                },
                component: () => import("@/views/admin/plot/plotManage.vue")
            },
            // 农业投入品
            {
                path: "productInputManage",
                name: "productInputManage",
                props: true,
                meta: {
                    title: "生产投入品使用情况"
                },
                component: () => import("@/views/admin/farmingInput/productInputManage.vue")
            },
            {
                path: "otherInputManage",
                name: "otherInputManage",
                props: true,
                meta: {
                    title: "其他投入品使用记录"
                },
                component: () => import("@/views/admin/farmingInput/otherInputManage.vue")
            },
            {
                path: "capitalInputManage",
                name: "capitalInputManage",
                props: true,
                meta: {
                    title: "农资投入记录"
                },
                component: () => import("@/views/admin/farmingInput/capitalInputManage.vue")
            },
            {
                path: "employManage",
                name: "employManage",
                props: true,
                meta: {
                    title: "用工明细"
                },
                component: () => import("@/views/admin/farmingInput/employManage.vue")
            },
            {
                path: "workshopManage",
                name: "workshopManage",
                props: true,
                meta: {
                    title: "车间管理"
                },
                component: () => import("@/views/admin/farmingInput/workshopManage.vue")
            },
            // 气象信息
            {
                path: "weatherList",
                name: "weatherList",
                props: true,
                meta: {
                    title: "气象信息"
                },
                component: () => import("@/views/admin/weather/weatherList.vue")
            },
            // 虫情信息
            {
                path: "insectList",
                name: "insectList",
                props: true,
                meta: {
                    title: "虫情信息"
                },
                component: () => import("@/views/admin/insect/insectList.vue")
            },
            // 设备管理
            {
                path: "equipManage",
                name: "equipManage",
                props: true,
                meta: {
                    title: "设备管理"
                },
                component: () => import("@/views/admin/equip/equipManage.vue")
            },
            {
                path: "monitorManage",
                name: "monitorManage",
                props: true,
                meta: {
                    title: "监控设备"
                },
                component: () => import("@/views/admin/equip/monitorManage.vue")
            },
            {
                path: "industryMonitorManage",
                name: "industryMonitorManage",
                props: true,
                meta: {
                    title: "监控设备"
                },
                component: () => import("@/views/admin/equip/industryMonitorManage.vue")
            },
            // 消息通知
            {
                path: "messageManage",
                name: "messageManage",
                props: true,
                meta: {
                    title: "消息通知"
                },
                component: () => import("@/views/admin/message/messageManage.vue")
            },
            {
                path: "exportList",
                name: "exportList",
                props: true,
                meta: {
                    title: "导出记录"
                },
                component: () => import("@/views/admin/export/exportList.vue")
            },
            {
                path: "industrialChain",
                name: "industrialChain",
                props: true,
                meta: {
                    title: "产业链"
                },
                component: () => import("@/views/admin/industry/industrialChain.vue")
            },
            {
                path: "industrialCluster",
                name: "industrialCluster",
                props: true,
                meta: {
                    title: "产业集群"
                },
                component: () => import("@/views/admin/industry/industrialCluster.vue")
            },
            // 农资管理
            {
                path: "lifeCycles",
                name: "lifeCycles",
                props: true,
                meta: {
                    title: "生长周期"
                },
                component: () => import("@/views/admin/farmingManage/lifeCycles.vue")
            },
            {
                path: "cultivatePlan",
                name: "cultivatePlan",
                props: true,
                meta: {
                    title: "种植计划"
                },
                component: () => import("@/views/admin/farmingManage/cultivatePlan.vue")
            },
            {
                path: "inventoryList",
                name: "inventoryList",
                props: true,
                meta: {
                    title: "库存清单"
                },
                component: () => import("@/views/admin/inventoryManage/inventoryList.vue")
            },
            {
                path: "operationRecord",
                name: "operationRecord",
                props: true,
                meta: {
                    title: "操作记录",
                    permissionRely: "/admin/inventoryList"
                },
                component: () => import("@/views/admin/inventoryManage/operationRecord.vue")
            },
            {
                path: "farmingYield",
                name: "farmingYield",
                props: true,
                meta: {
                    title: "农产品产量信息"
                },
                component: () => import("@/views/admin/yieldManage/farmingYield.vue")
            },
            {
                path: "beastsYield",
                name: "beastsYield",
                props: true,
                meta: {
                    title: "畜禽产品产量信息"
                },
                component: () => import("@/views/admin/yieldManage/beastsYield.vue")
            },
            {
                path: "preliminaryYield",
                name: "preliminaryYield",
                props: true,
                meta: {
                    title: "初加工产量信息"
                },
                component: () => import("@/views/admin/yieldManage/preliminaryYield.vue")
            },
            {
                path: "furtherYield",
                name: "furtherYield",
                props: true,
                meta: {
                    title: "深加工产量信息"
                },
                component: () => import("@/views/admin/yieldManage/furtherYield.vue")
            },
            {
                path: "traceList",
                name: "traceList",
                props: true,
                meta: {
                    title: "溯源码管理"
                },
                component: () => import("@/views/admin/traceManage/traceList.vue")
            },
            // 工业管理
            {
                path: "environmentDetection",
                name: "environmentDetection",
                props: true,
                meta: {
                    title: "车间环境监测"
                },
                component: () => import("@/views/admin/industryManage/environmentDetection.vue")
            },
            {
                path: "qualityDetection",
                name: "qualityDetection",
                props: true,
                meta: {
                    title: "产品质量信息监测"
                },
                component: () => import("@/views/admin/industryManage/qualityDetection.vue")
            },
            {
                path: "nutritionalIngredient",
                name: "nutritionalIngredient",
                props: true,
                meta: {
                    title: "营养成分表"
                },
                component: () => import("@/views/admin/industryManage/nutritionalIngredient.vue")
            },
            {
                path: "flowManage",
                name: "flowManage",
                props: true,
                meta: {
                    title: "流程管理"
                },
                component: () => import("@/views/admin/industryManage/flowManage.vue")
            },
            // 原料包材管理
            {
                path: "materialPut",
                name: "materialPut",
                props: true,
                meta: {
                    title: "原料入库明细"
                },
                component: () => import("@/views/admin/materialAndWrapper/materialPut.vue")
            },
            {
                path: "materialDelivery",
                name: "materialDelivery",
                props: true,
                meta: {
                    title: "原料出库明细"
                },
                component: () => import("@/views/admin/materialAndWrapper/materialDelivery.vue")
            },
            {
                path: "wrapperPut",
                name: "wrapperPut",
                props: true,
                meta: {
                    title: "包材入库明细"
                },
                component: () => import("@/views/admin/materialAndWrapper/wrapperPut.vue")
            },
            {
                path: "wrapperDelivery",
                name: "wrapperDelivery",
                props: true,
                meta: {
                    title: "原料出库明细"
                },
                component: () => import("@/views/admin/materialAndWrapper/wrapperDelivery.vue")
            }
        ]
    },
    {
        path: "/error403",
        name: "error403",
        component: () => import("@/views/error/403.vue")
    }
];
export {
    routes
};



// WEBPACK FOOTER //
// ./src/router/routes.js